<div class="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-indigo-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <img class="mx-auto h-12 w-auto" src="https://storage.googleapis.com/monecocmsfiles/logo_moneco_full_01ed69a2e8.svg" alt="Moneco">
    <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">Set new password</h2>
    <p class="mt-2 text-center text-sm text-gray-600">
      Enter a new, secure password for your account.
    </p>
  </div>

  <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
    <div class="bg-white py-8 px-6 shadow rounded-lg sm:px-10">

      <!-- Error Alert -->
      <div *ngIf="errorMessage" class="mb-6 bg-red-50 border-l-4 border-red-400 p-4 rounded-md animate-fade-in-up">
        <div class="flex">
          <div class="shrink-0">
            <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-red-700 font-medium">{{ errorMessage }}</p>
          </div>
        </div>
      </div>

      <!-- Success Notification -->
      <div *ngIf="success" class="text-center animate-fade-in-up">
        <div class="flex items-center justify-center mt-4">
          <div class="bg-green-100 rounded-full p-4 shadow-inner">
            <svg class="h-12 w-12 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>
        <h3 class="mt-6 text-lg font-semibold text-gray-900">Password updated!</h3>
        <p class="mt-2 text-sm text-gray-600">
          Your password has been changed successfully. Redirecting you...
        </p>
      </div>

      <!-- Reset Password Form -->
      <form #resetForm="ngForm" (ngSubmit)="submitResetPassword()" class="space-y-6" *ngIf="!success">
        <div>
          <label for="new-password" class="block text-sm font-medium text-gray-700">New password</label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input [(ngModel)]="password"
                   name="password"
                   #newPwdInput="ngModel"
                   required
                   minlength="8"
                   [type]="showPassword ? 'text' : 'password'"
                   id="new-password"
                   placeholder="At least 8 characters"
                   class="block w-full rounded-md border border-gray-300 shadow-sm px-3 py-2 pr-10 text-base placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
            <button type="button"
                    (click)="toggleShowPassword()"
                    class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600">
              <svg *ngIf="!showPassword" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <svg *ngIf="showPassword" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l18 18" />
              </svg>
            </button>
          </div>
          <p *ngIf="newPwdInput.invalid && (newPwdInput.dirty || newPwdInput.touched)" class="mt-2 text-sm text-red-600">
            <span *ngIf="newPwdInput.errors?.['required']">Password is required.</span>
            <span *ngIf="newPwdInput.errors?.['minlength']">Password must be at least 8 characters long.</span>
          </p>
        </div>

        <div>
          <label for="confirm-password" class="block text-sm font-medium text-gray-700">Confirm new password</label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input [(ngModel)]="confirmPassword"
                   name="confirmPassword"
                   #confirmPwdInput="ngModel"
                   required
                   [type]="showConfirmPassword ? 'text' : 'password'"
                   id="confirm-password"
                   placeholder="Repeat new password"
                   class="block w-full rounded-md border border-gray-300 shadow-sm px-3 py-2 pr-10 text-base placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
            <button type="button"
                    (click)="toggleShowConfirmPassword()"
                    class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600">
              <svg *ngIf="!showConfirmPassword" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <svg *ngIf="showConfirmPassword" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l18 18" />
              </svg>
            </button>
          </div>
          <p *ngIf="confirmPassword && password !== confirmPassword" class="mt-2 text-sm text-red-600">
            Passwords do not match.
          </p>
        </div>

        <div>
          <button type="submit"
                  [disabled]="resetForm.invalid || (password !== confirmPassword) || loading"
                  class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition duration-150 ease-in-out">
            <svg *ngIf="loading" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
            </svg>
            <span>{{ loading ? 'Updating password...' : 'Update password' }}</span>
          </button>
        </div>

        <div class="text-center">
          <a routerLink="/auth/login" class="text-sm font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out">
            Return to sign in
          </a>
        </div>
      </form>

    </div>
  </div>
</div>
